export default __webpack_public_path__ + "static/dmytro-popovych-70cd316e2e5cda08420dbe019bbf991c.png";